import React, { useState } from "react";
import { X } from "lucide-react";

const ContactPopup = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    countryCode: "+1",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const countryCodes = [
    { code: "+1", country: "US/Canada" },
    { code: "+44", country: "UK" },
    { code: "+91", country: "India" },
    { code: "+61", country: "Australia" },
    { code: "+81", country: "Japan" },
    { code: "+86", country: "China" },
    { code: "+49", country: "Germany" },
    { code: "+33", country: "France" },
    { code: "+39", country: "Italy" },
    { code: "+34", country: "Spain" },
    { code: "+7", country: "Russia" },
    { code: "+55", country: "Brazil" },
    { code: "+52", country: "Mexico" },
    { code: "+27", country: "South Africa" },
    { code: "+82", country: "South Korea" },
    { code: "+971", country: "UAE" },
    { code: "+65", country: "Singapore" },
    { code: "+60", country: "Malaysia" },
    { code: "+63", country: "Philippines" },
    { code: "+64", country: "New Zealand" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "phone") {
      const numericValue = value.replace(/\D/g, "").slice(0, 15);
      setFormData({ ...formData, [name]: numericValue });
    } else {
      setFormData({ ...formData, [name]: value });
    }
    
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      setIsSubmitting(true);
      
      setTimeout(() => {
        console.log("Form submitted:", formData);
        setIsSubmitting(false);
        setSubmitSuccess(true);
        
        setTimeout(() => {
          setFormData({
            name: "",
            email: "",
            countryCode: "+1",
            phone: "",
            message: "",
          });
          setSubmitSuccess(false);
          onClose();
        }, 2000);
      }, 1000);
    }
  };

  const handleClose = () => {
    setFormData({
      name: "",
      email: "",
      countryCode: "+1",
      phone: "",
      message: "",
    });
    setErrors({});
    setSubmitSuccess(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="contact-popup-overlay" onClick={handleClose}>
      <div className="contact-popup-content" onClick={(e) => e.stopPropagation()}>
        <button className="contact-popup-close" onClick={handleClose} aria-label="Close popup">
          <X size={20} />
        </button>

        <h2 className="contact-popup-title">Get Started with Your Trademark</h2>

        {submitSuccess ? (
          <div className="contact-success-message">
            <div className="contact-success-icon">✓</div>
            <h4>Thank You!</h4>
            <p>We'll contact you soon.</p>
          </div>
        ) : (
          <form className="contact-popup-form" onSubmit={handleSubmit}>
            <div className="contact-form-field">
              <label htmlFor="name" className="contact-form-label">Full Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={`contact-form-input ${errors.name ? "error" : ""}`}
                placeholder="Enter your full name"
              />
              {errors.name && <span className="contact-error-msg">{errors.name}</span>}
            </div>

            <div className="contact-form-field">
              <label htmlFor="email" className="contact-form-label">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`contact-form-input ${errors.email ? "error" : ""}`}
                placeholder="your.email@example.com"
              />
              {errors.email && <span className="contact-error-msg">{errors.email}</span>}
            </div>

            <div className="contact-form-field">
              <label htmlFor="phone" className="contact-form-label">Contact Number</label>
              <div className="contact-phone-group">
                <select
                  name="countryCode"
                  value={formData.countryCode}
                  onChange={handleChange}
                  className="contact-country-select"
                  aria-label="Country code"
                >
                  {countryCodes.map((item) => (
                    <option key={item.code} value={item.code}>
                      {item.code} {item.country}
                    </option>
                  ))}
                </select>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="contact-form-input contact-phone-input"
                  placeholder="1234567890"
                />
              </div>
            </div>

            <div className="contact-form-field">
              <label htmlFor="message" className="contact-form-label">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="contact-form-textarea"
                placeholder="Tell us about your trademark needs..."
                rows="3"
              />
            </div>

            <button
              type="submit"
              className="contact-submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Submitting..." : "Submit Request"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactPopup;
